import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';
import { TimerService } from '../../../../../../services/timer.service';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'auto-play-resource',
    template: require('./auto-play-resource.component.html'),
})
export class AutoPlayResourceComponent implements OnInit, OnDestroy {
    @Input() type: string;
    @Input() resourceId: number;
    @Input() time: number;


    intervalSubscription: Subscription;
    timeLeft: string;
    private resourceVisible = false;
    skipHotKeyPressed: boolean = false;
    keyDownSubscription: Subscription;

    constructor(
        private timerService: TimerService,
    ) {
    }

    ngOnInit() {
        this.time *= this.timerService.timer.multiplier;
        this.timeLeft = this.time.toString();

        if (_paragonConfig.shortcutsEnabled === true) {
            this.keyDownSubscription = Observable.fromEvent<KeyboardEvent>(document, "keydown")
            .filter(x => x.keyCode == 114)
            .subscribe(x => this.skipHotKeyPressed = true);
        }

        this.intervalSubscription = Observable.interval(1000)
            .take(this.time)
            .subscribe(
                secondsElapsed => {
                    if(this.skipHotKeyPressed){
                        this.skipHotKeyPressed = false;
                        this.intervalSubscription.unsubscribe();
                        this.resourceVisible = true;
                    }else{
                        const timeLeft = this.time - secondsElapsed - 1;
                        this.timeLeft = timeLeft.toString();
                    }
                },
                error => console.log(error),
                () => {
                    this.resourceVisible = true;
                }
            );
    }

    ngOnDestroy() {
        if(this.keyDownSubscription){
            this.keyDownSubscription.unsubscribe();
        }
        if (this.intervalSubscription) {
            this.intervalSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/auto-play-resource/auto-play-resource.component.ts